import { actions } from './reducer';

let counter = 0;

export const removeNotification = (id) => (dispatch, getState) => {
  const state = getState().notification;
  const index = state.findIndex((item) => item.id === id);

  if (index !== -1) {
    const item = state[index];

    if (item.visible) {
      item.visible = false;
      dispatch(actions.setNotifications(state));
      setTimeout(() => dispatch(removeNotification(id)), 300);
    } else {
      state.splice(index, 1);
      dispatch(actions.setNotifications(state));
    }
  }
};

export const showNotification = ({ type = 'SUCCESS', message }) => (dispatch, getState) => {
  const state = getState().notification;
  const id = ++counter;
  const notification = {
    id,
    type,
    message,
    visible: true,
  };

  state.push(notification);
  dispatch(actions.setNotifications(state));
  setTimeout(() => dispatch(removeNotification(id)), 3000);
};
